import { State } from "@progress/kendo-data-query";

export const InitialState: State = {
  take: 25,
  skip: 0,
  sort: [],
};
